import React from "react";

import styles from "./ErrorMessage.module.css";

interface Props {
  error: boolean;
  errorMessage: string | JSX.Element;
}

const ErrorMessage: React.FC<Props> = (props) => {
  return props.error ? (
    <span className={`${styles.ErrorMessage}`}>{props.errorMessage}</span>
  ) : null;
};

export default ErrorMessage;
